/**
 * @file
 * Custom js file for related companies project.
 */
(function($, Drupal, debounce, once) {
  'use strict';

  Drupal.behaviors.RCC = {
    attach: function(context) {

      $(window).bind('resize', function() {
        mobileHeaderJS();
        filterJS();
        ctaScrollJS();
      }).trigger('resize');

      function mobileHeaderJS() {
        if ($(window).width() < 1200) {
          // Hamburger & Main menu toggle things.
          $('.toggle-hamburger').on('click', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $(this).toggleClass('toggle-open');
            $('body').toggleClass('menu-active');
            $('.rcc-offcanvas-menu').toggleClass('offcanvas-menu-open');
            $('.main-menu .has-dropdown a').siblings('.dropdown-menu').removeClass('menu-slides-open').css('position', 'fixed');
            $('#header, .rcc-offcanvas-menu').removeAttr('style');
            $('#header .toggle-hamburger span').css('background-color', '#fff');
            $('#header .logo svg path, #header #search-icon svg mask, #header #search-icon svg g').css('fill', '#fff');
            $('.select-site-menu > li').removeClass('sites-open');
            if ($('.select-site-menu .menu').css('display') === 'block') {
              $('.select-site-menu .menu').hide();
            }
          });

          $('.main-menu .has-dropdown > a').on('click', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $(this).siblings('.dropdown-menu').toggleClass('menu-slides-open');
            var slideMenuBgColor = $(this).siblings('.dropdown-menu').css('background-color');
            var bgColor = $(this).siblings('.dropdown-menu').find('ul li a').css('color');
            $('#header, .rcc-offcanvas-menu').css('background-color', slideMenuBgColor);
            $('#header .toggle-hamburger span').css('background-color', bgColor);
            $('#header .logo svg path, #header #search-icon svg mask, #header #search-icon svg g').css('fill', bgColor);
          });

          $('.nav-back a').on('click', function(e) {
            e.preventDefault();
            $(this).closest('.dropdown-menu').removeClass('menu-slides-open');
            var backBgColor = $(this).closest('.dropdown-menu').siblings('a').css('color');
            $('#header .toggle-hamburger span').css('background-color', backBgColor);
            $('#header .logo svg path, #header #search-icon svg mask, #header #search-icon svg g').css('fill', backBgColor);
            if ($(this).closest('.dropdown-menu').parents('.dropdown-menu').length > 0) {
              var backSlideMenuBgColor = $(this).closest('.dropdown-menu').parents('.dropdown-menu').css('background-color');
              $('#header, .rcc-offcanvas-menu').css('background-color', backSlideMenuBgColor);
            } else {
              $('#header, .rcc-offcanvas-menu').css('background-color', '#001b38');
            }
          });

          // Header Select site menu onClick collapsed
          $('.select-site-menu > li > a').on('click', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $(this).parent('li').toggleClass('sites-open');
            if ($('.select-site-menu .menu').css('display') === 'none') {
              $('.select-site-menu .menu').fadeIn(400);
            } else {
              $('.select-site-menu .menu').hide();
            }
          });

          // Sticky header in mobile when user logged in and toolbar is visible.
          var s = $('.user-logged-in.toolbar-vertical #header');
          var pos = s.offset();
          $(window).scroll(debounce(function () {
            if (s.length) {
              var windowpos = $(window).scrollTop();
              if (windowpos >= pos.top) {
                s.addClass('stick');
              } else {
                s.removeClass('stick');
              }
            }
          }, 50));
        } else {
          $('.toggle-hamburger').removeClass('toggle-open');
          $('body').removeClass('menu-active');
          $('.rcc-offcanvas-menu').removeClass('offcanvas-menu-open');
          $('#header, .rcc-offcanvas-menu').removeAttr('style');
          $('.main-menu .has-dropdown .dropdown-menu').removeClass('menu-slides-open').css('position', 'absolute');
          $('#header .toggle-hamburger span').css('background-color', '#fff');
          $('#header .logo svg path, #header #search-icon svg mask, #header #search-icon svg g').css('fill', '#fff');
        }
      }

      function removeFilterOverlay(){
        $('.filter-overlay').remove();
        $('body').removeClass('filter-active');
        $('.filters').removeClass('show-filter-item');
      }

      function filterJS() {

        var f = $('.filters');

        if ($(window).width() < 1024) {
          // Filter show/hide - Filter items
          $('.filters .controls span.show').on('click', function(e) {
            e.stopImmediatePropagation();
            $('.filters').addClass('show-filter-item');
            $('body').addClass('filter-active').append('<div class=\'filter-overlay\'>');
          });
          $('.filters .controls span.hide').on('click', function(e) {
            e.stopImmediatePropagation();
            $('.filters').removeClass('show-filter-item');
            $('body').removeClass('filter-active');
            $('.filter-overlay').remove();
          });
          // When a filter has been applied, remove filter overlays
          $(document).ajaxStop(function () {
            removeFilterOverlay();
            if ($('#header').hasClass('filter-active')) {
              $('.filters').addClass('sticky-filter--top');
            }
          });
        }
      }

      // Search icon click open Search overlay
      $('.search-icon').on('click keydown', function(event) {  
        if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
          event.preventDefault();
          $('.search-overlay').animate({
            top: 0
          }, 500);
          $('body').addClass('search-overlay-active');
          $('.search-overlay form .form-item-search input').focus();
          $('.search-overlay .close-overlay').attr('tabindex','0');
          $('.search-overlay').find(':input').attr('tabindex','0');
        }
      });
      $('.search-overlay .close-overlay').on('click keydown', function(event) {
        if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
          $('.search-overlay').animate({
            top: -5000
          }, 500);
          $('body').removeClass('search-overlay-active');
          $('.search-overlay .close-overlay').attr('tabindex','-1');
          $('.search-overlay').find(':input').attr('tabindex','-1');
        }
      });

      // Search result page.
      if ($('.search-results-wrapper .search-input-field form [id^=\'edit-reset\']').length) {
        $('.search-results-wrapper .search-input-field form .form-actions').addClass('hasReset');
      } else {
        $('.search-results-wrapper .search-input-field form .form-actions').removeClass('hasReset');
      }

      // Availability search block.
      $(once('bind-availability-search-block-click-event', '.block-availability-search-block h2')).each(function () {
        $(this).on('click', function() {
          $('.block-availability-search-block h2').toggleClass('active');
          $('.block-availability-search-block > form').toggleClass('active');
          e.preventDefault();
        });
      });

      // Social Hashtag slider & Fancybox
      if ($.fn.slick) {
        $('.social-hashtag', context).slick({
          rows: 2,
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesPerRow: 1,
          slidesToScroll: 4,
          slidesToShow: 4,
          initialSlide: 0,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesPerRow: 1,
                rows: 2,
                slidesToScroll: 3,
                slidesToShow: 3,
                dots: false,
              }
            },
            {
              breakpoint: 768,
              settings: {
                rows: 1,
                slidesPerRow: 1,
                slidesToScroll: 1,
                slidesToShow: 1,
                dots: false,
                arrows: false,
                centerMode: true,
                draggable: false,
                centerPadding: '16px',
              }
            }
          ]
        });
      }

      if ($.fn.fancybox) {
        $('.social-hashtag .image').fancybox({
          loop: true,
          afterLoad: (instance, slide) => {
            // Do not run AJAX more than once per slide.
            $(once('ajax-downloaded', slide.$content)).each(function () {
              // Get media entity id for using in AJAX endpoint url.
              const media_id = slide.$content.data('media-id');
              // Construct the URL for the AJAX request  
              var ajaxUrl = '/ajax/fancybox/instagram/' + media_id;
              $.ajax({
                url: ajaxUrl,
                type: 'GET',
                dataType: 'json', // Expect a JSON response
                success: function success(response) {
                  // Use Drupal's AJAX framework to execute the command
                    if (response && response.length) {
                      var ajaxCommands = response;
                      for (var i = 0; i < ajaxCommands.length; i++) {
                        var command = ajaxCommands[i];
                        // Execute the command if it exists
                        if (command.command && Drupal.AjaxCommands.prototype[command.command]) {
                        
                          var $placeholder = $(`#instaModal-${media_id} .ajax-placeholder`);  
                          $placeholder.html(command.data);  
                          
                          // Find and execute scripts inside the placeholder  
                          $placeholder.find('script').each(function() {  
                            $.globalEval(this.text || this.textContent || this.innerHTML || '');  
                          });   
                        }
                      }
                      if (typeof instgrm !== 'undefined'){ 
                        instgrm.Embeds.process();  
                      }
                    }
                },
                error: function error(xhr, status, _error) {
                  console.error('AJAX error:', status, _error);
                }
              });
            });
          }
        }).attr('data-fancybox', 'gallery');
      }

      if ($.fn.slick) {
        // Get carousel element
        var slick_pillars = $('.slick--pillars', context);
        // Carousel settings
        var settings = {
          infinite: false,
          responsive: [{
            breakpoint: 4480,
            settings: 'unslick'
          },
          {
            breakpoint: 767,
            settings: {
              rows: 1,
              slidesPerRow: 1,
              slidesToScroll: 1,
              slidesToShow: 1,
              dots: false,
              arrows: false,
              centerMode: true,
              draggable: false,
              initialSlide: 0,
              centerPadding: '16px',
            }
          }]
        }
        // Initialize the Slick carousel
        if (slick_pillars) {
          slick_pillars.slick(settings);
        }

        // Get carousel element
        var propertyCardsThreeSlider = $('.property__cards.for-three .field--name-field-properties.field__items',context);
        var propertyCardsFourSlider = $('.property__cards.for-four .field--name-field-properties.field__items',context);
        // Carousel settings
        var propertyCardSlickSettings = {
          infinite: false,
          responsive: [{
            breakpoint: 4480,
            settings: 'unslick'
          }, 
          {
            breakpoint: 767,
            settings: {
              rows: 1,
              slidesPerRow: 1,
              slidesToScroll: 1,
              slidesToShow: 1,
              dots: false,
              arrows: false,
              centerMode: true,
              draggable: false,
              initialSlide: 0,
              centerPadding: '16px'
            }
          }]
        };

        // Initialize the Slick carousel
        if (propertyCardsThreeSlider) {
          propertyCardsThreeSlider.slick(propertyCardSlickSettings);
        } 
        if (propertyCardsFourSlider) {
          propertyCardsFourSlider.slick(propertyCardSlickSettings);
        }

        if (propertyCardsThreeSlider || propertyCardsFourSlider || slick_pillars) {
          $(window).on('resize', function () {
            // If we are below mobile breakpoint and the slick instance has been destroyed, reinit the slider
            var windowWidth = $(window).width();
            if (windowWidth <= 767 && !slick_pillars.hasClass('slick-initialized')) {
                slick_pillars.slick(settings);
            }
            if (windowWidth <= 767 && !propertyCardsThreeSlider.hasClass('slick-initialized')) {
                propertyCardsThreeSlider.slick(propertyCardSlickSettings);
            }
            if (windowWidth <= 767 && !propertyCardsFourSlider.hasClass('slick-initialized')) {
              propertyCardsFourSlider.slick(propertyCardSlickSettings);
            }
          });
        }

        $('.spotlight.slick', context).slick({
          infinite: false,
          speed: 300,
          slidesPerRow: 1,
          slidesToScroll: 1,
          slidesToShow: 1,
          initialSlide: 0,
          centerMode: true,
          centerPadding: '16px',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                rows: 1,
                slidesPerRow: 1,
                slidesToScroll: 1,
                slidesToShow: 1,
                arrows: false,
                centerMode: true,
                draggable: true,
                initialSlide: 0,
              }
            },
            {
              breakpoint: 1024,
              settings: {
                arrows: false
              }
            }
          ]
        });

        // Property detail page gallery slick slider.
        $('.property-gallery .field__items', context).slick({
          initialSlide: 0,
          infinite: true,
          arrows: true,
          dots: false,
          centerMode: true,
          variableWidth: true,
          slidesToShow: 1,
          centerPadding: '24px',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: false,
              }
            }
          ]
        });
        // Image Grid Slick only on mobile.
        $('.unslick--imagegrid', context).slick({
          infinite: false,
          responsive: [
            {
              breakpoint: 4480,
              settings: 'unslick'
            },
            {
              breakpoint: 768,
              settings: {
                dots: false,
                draggable: true,
                initialSlide: 0,
                slidesToScroll: 1,
                slidesToShow: 1
              }
            }
          ]
        });
        // Carousel [4x1].
        $('.carousel--imagegrid-four', context).slick({
          arrows: true,
          dots: false,
          draggable: true,
          infinite: false,
          speed: 300,
          slidesToScroll: 4,
          slidesToShow: 4,
          initialSlide: 0,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
        // Carousel [4x2].
        $('.carousel--imagegrid-twobyfour', context).slick({
          rows: 2,
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesPerRow: 1,
          slidesToScroll: 4,
          slidesToShow: 4,
          initialSlide: 0,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToScroll: 3,
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                rows: 1,
                slidesToScroll: 1,
                slidesToShow: 1,
              }
            }
          ]
        });
        // Carousel [6x1].
        $('.carousel--imagegrid-six', context).slick({
          arrows: true,
          dots: false,
          infinite: false,
          speed: 300,
          slidesToScroll: 6,
          slidesToShow: 6,
          initialSlide: 0,
          draggable: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToScroll: 1,
                slidesToShow: 1
              }
            }
          ]
        });
        // Carousel [6x2].
        $('.carousel--imagegrid-twobysix', context).slick({
          rows: 2,
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesPerRow: 1,
          slidesToScroll: 6,
          slidesToShow: 6,
          initialSlide: 0,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToScroll: 3,
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                rows: 1,
                slidesPerRow: 1,
                slidesToScroll: 1,
                slidesToShow: 1,
                draggable: true,
              }
            }
          ]
        });
      }

      // Accessibility
      $('a').keyup(function(e) {
        $('a').removeClass('focus--indicator');
        if (e.which === 9) {
          $(this).addClass('focus--indicator');
          e.preventDefault();
        }
      });

      //Tab Content JQuery.
      $('.featured-news-switcher .main-content-switcher').click(function() {
        var tab_id = $(this).attr('data-tab');
        $('.featured-news-switcher .main-content-switcher').removeClass('active');
        $('.featured-news-content .carousel-content').removeClass('active');
        $(this).addClass('active');
        $('#' + tab_id).addClass('active');
      });

      $('.featured-blog-post-switcher .main-content-switcher').click(function() {
        var tab_id = $(this).attr('data-tab');

        $('.featured-blog-post-switcher .main-content-switcher').removeClass('active');
        $('.featured-blog-post-content .carousel-content').removeClass('active');
        $(this).addClass('active');
        $('#' + tab_id).addClass('active');
      });

      // Scroll to content on blog post
      const urlParams = new URLSearchParams(window.location.search);
      if(urlParams.has('scroll-to')) {
        const scrollTo = urlParams.get('scroll-to');
        var element = document.getElementById(scrollTo);
        var headerOffset = 100;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }

      // Inspirational card.
      $('.inspirational--card').on('click', function() {
        $(this).addClass('active');
        var $siblings = $(this).siblings('.inspirational--card');
        $siblings.removeClass('active now-playing');
        $siblings.each(function() {
          $($(this).find('.plyr__video-wrapper').first()[0]).removeClass('inspirational-narrow-video');
        });
        if($(this).hasClass('active')){
          var wrapper = $(this).find('.plyr__video-wrapper').first()[0];
          if(wrapper.getBoundingClientRect().width<wrapper.offsetParent.getBoundingClientRect().width){
            $(wrapper).addClass('inspirational-narrow-video');
          }
          if($(this).find('.plyr__video-embed__container').length > 0) {
            var $wrapper = $(this).find('.plyr__video-wrapper').first()[0];
            setPlyrWrapperPadding($wrapper);
          }
        }
      });

      $('.inspirational--card .play__pause, .storypage--card .play__pause').each(function() {
        $(this).on('click', function() {
          $(this).parent().siblings('.inspirational--card, .storypage--card').find('.video--player').trigger('pause');
          $(this).parent().siblings('.inspirational--card, .storypage--card').find('.video--player').removeAttr('controls');
          $(this).parent().find('.video--player').attr('controls', 'controls');
          var videoEl = $(this).parent().find('.video--player');
          if (videoEl.get(0).paused) {
            videoEl.trigger('play');
            $(this).hide();
            $(this).parent().addClass('now-playing');
          } else {
            videoEl.trigger('pause');
            $(this).show();
            $(this).parent().removeClass('now-playing');
          }
        });
      });

      $('.storypage--card, .paragraph--type--text-and-image').each(function() {
        $(this).on('click', function() {
          var $wrapper = $(this).find('.plyr__video-wrapper').first()[0];
          setPlyrWrapperPadding($wrapper);
        });
      });

      $('.click-overlay').each(function() {
        $(this).on('click', function() {
          $(this.offsetParent).trigger('click');
        });
      });

      $('.video--player').on('ended', function() {
        $(this).removeAttr('controls');
        $(this).parent().find('.play__pause').show();
        $(this).parent().removeClass('now-playing');
        this.currentTime = 0.1;
      });

      // Spotlight/Storypage: Pause Video if navigate to next slide - slick.
      $('.Storypage .slick-arrow, .Spotlight .slick-arrow').on('click', function() {
        $('.storypage--card').each(function() {
          $(this).find('.video--player').trigger('pause');
          $(this).find('#vimeo-iframe').vimeo('pause');
          $(this).find('.spotlight--card__image').removeClass('now-playing');
        });
      });

      // Property explorer slick slider.
      // Slick needs no get Reinitialized on window Resize after it was destroyed
      $(window).on('load resize orientationchange', function() {
        $('.property-image').each(function() {
          var $carousel = $(this);
          /* Initializes a slick carousel only on mobile screens */
          // slick on mobile
          if ($(window).width() > 1023) {
            if ($carousel.hasClass('slick-initialized')) {
              $carousel.slick('unslick');
            }
          } else {
            if (!$carousel.hasClass('slick-initialized')) {
              $carousel.slick({
                initialSlide: 0,
                infinite: true,
                arrows: false,
                dots: false,
                centerMode: true,
                variableWidth: false,
                slidesToShow: 1,
                centerPadding: '16px',
              });
            }
          }
        });
      });

      $(window).on('load resize scroll', function() {
        offsetSocialIcons();
      });

      /**
       * Offsets the social icons to prevent it from overlapping with the footer.
       */
      function offsetSocialIcons() {
        if ($('.share-element-wrapper').length > 0) {
          var footerRect = $('#footer').get(0).getBoundingClientRect();
          var shareElementRect = $('.share-element-wrapper').get(0).getBoundingClientRect();
          var shareElementOverlap = shareElementRect.top - (shareElementRect.bottom - footerRect.top);

          if (shareElementOverlap <= 180) {
            $('.share-element-wrapper').css('top', shareElementOverlap + 'px');
          }
          else {
            $('.share-element-wrapper').css('top', '180px');
          }
        }
      }

      // Contact us form modal.
      $('.contact-us-popup').on('click', function (e) {
        e.preventDefault();
        $('aside.offscreen-element').addClass('visible-contact-modal');
        $('aside.offscreen-element .contactus-form').addClass('show');
        $('body').addClass('search-overlay-active');

        var $contact_form = $('form.webform-submission-contact-us-form-form');

        var $interest_field = $contact_form.find('.form-item-interest');
        var $interest_select_field = $interest_field.find('select[name="interest"]');

        var default_term_id = $(this).siblings('.interest-default').attr('term-id');
        var term_ids = $(this).siblings('.interest').attr('term-id');
        var hide = $(this).siblings('.hide-interest').attr('field-hide-interested-in');
        
        $interest_select_field.children('option').removeAttr("selected");

        if (hide == 1) {
          $('input[name="is_interest_hidden"]').val("1").trigger('change');
          $interest_field.hide();
        }
        else {
          $('input[name="is_interest_hidden"]').val("0").trigger('change');
          $interest_field.show();
        }

        if (term_ids.length > 0) {
          $interest_select_field.children('option').hide();
          term_ids.split(',').forEach(function(selected, index) {
            $interest_select_field.children("option[value^=" + selected + "]").show();
          });
        }

        if (default_term_id.length > 0) {
          $interest_select_field.find('option[value=' + default_term_id + ']')
          .attr("selected", "selected")
          .show();
          $interest_select_field.val(default_term_id).trigger('change');
        }

        var $marketing_field = $contact_form.find('.form-item-how-did-you-hear-about-us');
        var $marketing_select_field = $marketing_field.find('select[name="how_did_you_hear_about_us"]');

        var marketing_default_term_id = $(this).siblings('.marketing-source-default').attr('term-id');
        var marketing_term_ids = $(this).siblings('.marketing-source').attr('term-id');
        var marketing_hide = $(this).siblings('.hide-marketing-source').attr('field-hide-marketing-source');

        $marketing_field.show();
        $marketing_select_field.children('option').removeAttr("selected");

        if (marketing_hide == 1) {
          $('.form-item-how-did-you-hear-about-us').hide();
        }

        if (marketing_term_ids.length > 0) {
          $marketing_select_field.children('option').hide();
          $marketing_select_field.find('option[value=""]').show();
          marketing_term_ids.split(',').forEach(function(selected, index) {
            $marketing_select_field.children("option[value^=" + selected + "]").show();
          });
        }

        if (marketing_default_term_id.length > 0) {
          $marketing_select_field.find('option[selected=selected]').removeAttr("selected");
          $marketing_select_field.find('option[value=' + marketing_default_term_id + ']')
          .attr("selected", "selected")
          .show();
        }

        var zip_code_hide = $(this).siblings('.hide-zip-code').attr('field-hide-zip-code');

        if (zip_code_hide == 1) {
          $('input[name="is_zip_code_hidden"]').val("1").trigger('change');
        }
        else {
          $('input[name="is_zip_code_hidden"]').val("0").trigger('change');
        }

        $('.contactus-form .form-item-terms-and-conditions .form-checkbox').change(function() {
          var form_submit = $('.contactus-form .form-submit')
          if (this.checked) {
            $(form_submit).removeAttr('disabled');
          }
          else if (!$(form_submit).attr('disabled')) {
            $(form_submit).attr('disabled', 'disabled')
          }
        });
      });

      $('aside.offscreen-element .close-overlay').on('click', function () {
        $('aside.offscreen-element').removeClass('visible-contact-modal');
        $('body').removeClass('search-overlay-active');
        setTimeout(function () {
          $('aside.offscreen-element .contactus-form').removeClass('show');
        }, 350);
      });

      // Property unit price range on change.
      $('.price-range-fieldset .form-item-min select').on('change', function (e) {
        var priceVal = this.value > 0 ? this.value : '';
        $('.form-item-field-unit-price-min input').val(priceVal);
      });
      $('.price-range-fieldset .form-item-max select').on('change', function (e) {
        var priceVal = this.value > 0 ? this.value : '';
        $('.form-item-field-unit-price-max input').val(priceVal);
      });

      // Property unit sorting on change.
      $('.block-unit-filter-form-block .form-item-unit-filter-form-custom select').on('change', function (e) {
        var changVal = this.value;
        $('.block-unit-filter-form-block .form-item-unit-filter-form-custom select option').removeAttr("selected");
        $('.block-unit-filter-form-block .form-item-unit-filter-form-custom select option[value=' + changVal + ']').attr("selected", "selected");
        $('.property-unit-search-form .form-item-sort-by select option').removeAttr("selected");
        $('.property-unit-search-form .form-item-sort-by select option[value=' + changVal + ']').attr("selected", "selected");

        var url = new URL(document.location.href);
        url.searchParams.set("sort_by", changVal);
        window.history.pushState("", "", url.href);
        // Submit the unit search exposed form
        $('#edit-submit-property-unit-search').trigger( "click" );
      });

      $(document).ajaxComplete(function () {
        if ($('aside.offscreen-element form.webform-submission-contact-us-form-form .form-item-terms-and-conditions input').is(':checked')) {
          $('aside.offscreen-element form.webform-submission-contact-us-form-form .form-actions input').removeAttr('disabled');
        }
        else {
          $('aside.offscreen-element form.webform-submission-contact-us-form-form .form-actions input').attr('disabled', 'disabled');
        }
      });

      // CTA Paragraph Scroll Functioning.
      function ctaScrollJS() {
        var $win = $(window);
        var $filter = $('.cta--paragraph.sticky--cta');
        var $filterSpacer = $('<div />', {
          'class': 'filter-drop-spacer',
          'height': $filter.outerHeight()
        });
        var ctaScrollHandler = () => {
          if (typeof $filter.offset() !== 'undefined') {
            if (!$filter.hasClass('fix') && $win.scrollTop() > $filter.offset().top) {
              $filter.before($filterSpacer);
              $filter.addClass('fix');
            }
            else if ($filter.hasClass('fix') && $win.scrollTop() < $filterSpacer.offset().top) {
              $filter.removeClass('fix');
              $filterSpacer.remove();
            }
          }
        };
        $win.scroll(ctaScrollHandler);
      }
    }
  };

  /**
   * Toggle Social Share Bar.
   */
  Drupal.behaviors.rcc_toggle_social_share_bar = {
    attach: function (context) {
      var $shareIconList = $('.share-icon-list', context);

      if ($shareIconList.is(':visible')) {
        $shareIconList.parent().addClass('active');
      }

      $('.share-icon').unbind('click').click(() => {
        $shareIconList.slideToggle(500).parent().toggleClass('active');
      });
    }
  };

  /**
   * Pushes user history back by click on Property node full page's Back link.
   *
   * @type {{attach: Drupal.behaviors.rcc_property_back_link.attach}}
   */
  Drupal.behaviors.rcc_property_back_link = {
    attach: function (context) {
      var pageIsPropertyNode = $(once('checkBodyClass', 'body')).hasClass('page-node-type-property');
      if (pageIsPropertyNode) {
        $('a.detail-back', context).on('click', function (e) {
          // Empty history is with length === 1. Not empty is > 1.
          if (window.history.length > 1) {
            // Prevent click.
            e.preventDefault();
            window.history.back();
          }
        });
      }
    }
  };

  /**
   * Handle Hero Carousel WCAG.
   */
    Drupal.behaviors.rcc_hero_carousel = {
    attach: function attach(context, drupalSettings) {
      var carousel = $(".paragraph--type--hero-carousel .slick");
      $(carousel).on('init', function() {
        // Ensure that elements are not able to be navigated to via keyboard
        $(this).find('.slick-prev, .slick-next').attr('tabindex', '-1');
      });
    }
  };

  /**
   * Custom functionality for Plyr video players.
   */
  Drupal.behaviors.rcc_theme_plyr_videos = {
    attach: function (context, drupalSettings) {
      // Add event listener to window object for handling plyr players
      // functionality once they will be fully initialized.
      window.addEventListener('rcc_plyr_players_ready', function (e) {
        // Stop all videos initially because they are loaded with time code in source URL.
        Drupal.behaviors.rcc_video.pauseAllPlaying();
        const currentPlayer = e.detail.player;
        // Add custom event handlers.
        if (typeof currentPlayer !== 'undefined' && currentPlayer !== null) {
          // @TODO: Figure out another solution to relosve 'video first frame as poster image' issue on iOS.
          if (currentPlayer.isHTML5 && !currentPlayer.config.autoplay) {
            const intervalDAMVideo = setInterval(() => {
              if (currentPlayer.ready) {
                clearInterval(intervalDAMVideo);
                currentPlayer.stop();
              }
            }, 500);
          }
          else {
            const intervalVimeoVideo = setInterval(() => {
              if (currentPlayer.ready) {
                clearInterval(intervalVimeoVideo);
                setTimeout(function () {
                  if(currentPlayer.elements.wrapper.getBoundingClientRect().width < currentPlayer.elements.wrapper.offsetParent.getBoundingClientRect().width){
                    $(currentPlayer.elements.wrapper).addClass('inspirational-narrow-video');
                  }
                }, 1000);
                $('.playlist__video .plyr__control--overlaid', context).on('click', e => {
                  $(e.target).closest('.plyr').addClass('plyr--started');
                  $(e.target).closest('.playlist__video').addClass('now-playing');
                });
                // Retrieve the poster URL path for a Vimeo video using the Vimeo API
                var requestURL = currentPlayer.config.urls.vimeo.api.toString().replace(/{(\d+)}/g, currentPlayer.media.firstChild.attributes['src'].value.toString());  
                fetch(requestURL).then(response => {
                    if (!response.ok) {  
                      throw new Error('Network response was not ok');  
                    }  
                    return response.json(); // Parse JSON  
                }).then(data => {
                  if (!data.thumbnail_url) {
                    throw new Error('Thumbnail URL not found in the response');
                  }
                  var url = new URL(data.thumbnail_url); // Get original image  
                  url.pathname = `${url.pathname.split('_')[0]}.jpg`; // Modify the URL path to get the poster image  
                  currentPlayer.poster = url.href; // Set the poster URL
                }).catch(error => {
                  console.error('Fetch error:', error);
                });
              }
            }, 500);
          }

          // Add class to mark that video has ended playing.
          currentPlayer.on('ended', event => {
            $(event.target)
              .addClass('plyr--stopped')
              .removeClass('plyr--started')
              .closest('.playlist__video').removeClass('now-playing');
          });

          currentPlayer.on('playing', event => {
            var $targetPlayer = $(event.target);
            // Add class to closest video wrapper.
            $targetPlayer.closest('.inspirational--card, .playlist__video').addClass('now-playing');
            // Pause playing video when it is scrolled out of the screen.
            var videoPosTop = $targetPlayer.offset().top;
            var videoPosBottom = videoPosTop + $targetPlayer.find('.plyr__video-wrapper').outerHeight();
            var pauseVideoScrollHandler = () => {
              var windowscrollTop = $(window).scrollTop() + 50; // Header height.
              var windowscrollBottom = $(window).scrollTop() + $(window).height();
              if (windowscrollTop > videoPosBottom || windowscrollBottom < videoPosTop) {
                $(window).off('scroll.pauseVideo');
                currentPlayer.pause();
              }
            };
            $(window).on('scroll.pauseVideo', debounce(pauseVideoScrollHandler, 50));
          });

          // Prevent slick slider draggin when interacting with Plyr inputs.
          const intervalPlyrDisableSlickDrag = setInterval(() => {
            if (currentPlayer.ready) {
              clearInterval(intervalPlyrDisableSlickDrag);

              var $plyrProgressBar = $(currentPlayer.elements.inputs.seek);
              var $plyrVolumeControl = $(currentPlayer.elements.inputs.volume);

              $plyrProgressBar.add($plyrVolumeControl).bind('mousedown', function() {
                $(this).closest('.slick').slick("slickSetOption", "draggable", false);
              });

              $plyrProgressBar.add($plyrVolumeControl).bind('mouseup', function() {
                $(this).closest('.slick').slick("slickSetOption", "draggable", true);
              });
            }
          }, 500);
        }

        // Stop video players when any Inspirational card is clicked so previous
        // playing videos should stop.
        $('.inspirational--card .click-overlay', context).on('click', () => {
          // If parent event dispatched it means that behavior and all its
          // methods are in global scope and available.
          Drupal.behaviors.rcc_video.pauseAllPlaying();
        });
        // Stop video players when slick slide changed.
        $('.slick:not(.paragraph--type--hero-carousel .slick)', context).on('afterChange', () => {
          Drupal.behaviors.rcc_video.pauseAllPlaying();
        });
      });
    },
  };

  function isInViewport(el) {
    if (el !== null) {
      const rect = el.getBoundingClientRect();
      return (
        (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) || // Element is fully within the viewport  
        (rect.top < 0 && rect.bottom >= 0) || // Element is entering from above  
        (rect.top < window.innerHeight && rect.bottom > window.innerHeight) // Element is entering from below  
      );
    }
  }

  /*
  The setPlyrWrapperPadding function sets vertical padding based on video aspect ratio.
  */
  function setPlyrWrapperPadding(wrapper) {
    if(wrapper.style.aspectRatio){
      var x = 0;
      var y = 0;
      [x ,y] = wrapper.style.aspectRatio.split('/');
      var padding = (100 / x) * y;
      wrapper.firstChild.style.paddingBottom = 'calc('+padding+'% + 200px)';
      wrapper.firstChild.style.transform = 'translateY(-100px)';
    }
  }


  /**
   * Handle Video gallery.
   */
  Drupal.behaviors.rcc_theme_video_gallery = {
    attach: function attach(context, settings) {
        if (settings.rcc_video != undefined) {
          var players = settings.rcc_video.plyrPlayers;
          Object.keys(players).forEach(function (playerId) {
            // Do not handle videos that out of current context.
            if (!$(playerId, context).length) {
              return;
            }
            else if(!$('.video-listing ' + playerId).hasClass('plyr--video')){
              new Plyr('.video-listing ' + playerId, players[playerId].options);
            }
          });
        }
        $('.playlist__overlay', context).on('click', function () {
          Drupal.behaviors.rcc_video.stopAllPlaying();
          $('.playlist__video').removeClass('now-playing video-playing');
          var thisParent = $(this).closest('.playlist__video');
          thisParent.addClass('now-playing');
          var vIndex = thisParent.attr('data-video-index');
          var thisParentParent = $(this).closest('.playlist__video').parent().parent();
          thisParentParent.find(`.playlist__hidden`).addClass('playlist__preview').removeClass('playlist__video playlist__active');
          var currentplay = thisParentParent.find(`.playlist__hidden[data-video-index='${vIndex}']`);
          Drupal.behaviors.rcc_video.pauseAllPlaying();
          currentplay.addClass('playlist__video playlist__active').removeClass('playlist__preview');
          currentplay.addClass('video-playing');
        });
      }
  };

  /**
   * Do not use soft wrap on facet if at least one item was selected.
   */
  Drupal.behaviors.rccFacetSoftLimit = {
    attach: function (context, settings) {
      const facetsSoftLimit = ((settings.facets) || []).softLimit || [];
      $.each(facetsSoftLimit, (facetId) => {
        const facetsList = $('ul[data-drupal-facet-id="' + facetId + '"]', context);
        facetsList.each((index, facet) => {
          // If at least one checkbox was selected then remove soft wrap.
          if ($(facet).find('input.facets-checkbox:checked').length > 0) {
            // Apply unrealistic soft limit for removing "Show less/more" link.
            Drupal.facets.applySoftLimit(facetId, 9999, settings);
            // Mark facet list to show all items forcely.
            // I'm feeling very sorry for this solution, but there is no easy
            // way to do the same in custom facet widget.
            $(facet).addClass('force-show-items');
            var showLessLabel = settings.facets.softLimitSettings[facetId].showLessLabel;
            $(facet).next().addClass('open').text(showLessLabel);
          }
        });
      });
    }
  };

  /**
   * Handle Image Grid slick slider.
   */
  Drupal.behaviors.rcc_image_grid_slick = {
    attach: function (context) {
      var $imageGridSlider = $('.image--grid .slick-slider', context);

      $imageGridSlider.each(function () {
        var $this = $(this);
        if ($this.find('.has--background__attached').length) {
          $this.addClass('with-background');
        }
        else {
          $this.addClass('no-background');
        }
      });
    }
  };

  /**
   * Handle Long form field.
   */
  Drupal.behaviors.rcc_longform_field = {
    attach: function (context) {
      var $longform = $('.longform.paragraph--type--text-and-image', context);
      if (!$longform.length) {
        return;
      }

      $longform.each(function () {
        var $this = $(this);
        var $componentContent = $this.find('.component-content');
        var $descLongform = $componentContent.find('.desc--longform');
        if (!$componentContent.length || !$descLongform.length) {
          return;
        }

        var $readMoreLink = $componentContent.find('.desc--longform + a.read-more');
        var $readMoreButton = $('<button/>', {
          'class': 'longform__read-more collapsed',
          text: 'Read More'
        });
        var descLongformInitHeight = $descLongform.outerHeight();
        var descLongformMaxHeight = 84;           // Equals to 3 lines of text.

        if (descLongformInitHeight > descLongformMaxHeight) {
          $readMoreLink.hide();
          $componentContent.addClass('collapsed');
          $descLongform.css('max-height', descLongformMaxHeight);
          $readMoreButton
            .appendTo($componentContent)
            .on('click', function () {
              var $this = $(this);
              $readMoreLink.toggle();
              if ($this.hasClass('collapsed')) {
                $descLongform.animate({ maxHeight: descLongformInitHeight }, 'slow');
                $componentContent.removeClass('collapsed');
                $this.text('Read Less').removeClass('collapsed');
              }
              else {
                $descLongform.animate({ maxHeight: descLongformMaxHeight }, 'slow');
                $componentContent.addClass('collapsed');
                $this.text('Read More').addClass('collapsed');
              }
            });
        }
      });
    }
  };

   /**
   * Handle Sticky Filter panel.
   */
   Drupal.behaviors.rcc_sticky_filter = {
    attach: function (context) {
      var $filters = $('.region-sidebar-first .filters');
      if ($filters.length) {
        $('#main', context).addClass('has-filter');

        $(window).bind('resize', () => {
          initialiseStickyFilter(this);
        }).trigger('resize');

        function initialiseStickyFilter() {
          if ($(window).width() < 1024) {
            var $header = $('#header');
            var $searchblock = $('.block-availability-search-block');
            var position = $(window).scrollTop();
            $filters.addClass('sticky-filter');

            var stickyFiltersScrollHandler = () => {
              var scroll = $(window).scrollTop();
              if (scroll < 0) {
                return;
              }
              if (scroll > position) {
                $filters.addClass('sticky-filter--top');
                $header.addClass('filter-active');
                $searchblock.addClass('filter-active');
              }
              else {
                $filters.removeClass('sticky-filter--top');
                $header.removeClass('filter-active');
                $searchblock.removeClass('filter-active');
              }
              position = scroll;
            };
            $(window).on('scroll', debounce(stickyFiltersScrollHandler, 50));
          }
        }
      }
    }
  };

  /**
   * Trigger Blazy loading images on Slick slider horizontal scroll.
   */
  Drupal.behaviors.rcc_slick_slider_blazy = {
    attach: function (context) {
      var isBlazy = Drupal.blazy || {};
      var $slickSlider = $('.slick-slider.slick-initialized', context);

      if (isBlazy) {
        $slickSlider.each(function () {
          var $this = $(this);

          $this.on('beforeChange.rccSlick', () => {
            var $src = $('.b-lazy:not(.b-loaded)', $this);

            if ($src.length) {
              // Enforces lazyload ahead to smoothen the UX.
              Drupal.blazy.init.load($src);
            }
          });
        });
      }
    }
  };

  /**
   * Handle rcc rentals search.
   */
  Drupal.behaviors.rcc_rentals_search = {
    attach: function (context) {
      var $rentalsSearch = $('.rcc-rentals-search', context);
      var $citySelect = $('#edit-city', $rentalsSearch);
      var $neighborhoodFormItem = $('.form-item-neighborhood', $rentalsSearch);
      var $neighborhoodSelect = $('#edit-neighborhood', $rentalsSearch);
      var $fieldsetPrice = $('#edit-price', $rentalsSearch);
      var $priceMax = $('#edit-price-maximum', $rentalsSearch);
      var $priceMin = $('#edit-price-minimum', $rentalsSearch);
      var $priceList = $('.custom-select__options', $rentalsSearch);
      var $priceListItems = $priceList.children('li');

      if (!$rentalsSearch.length) {
        return;
      }

      // Hide Neighborhood dropdown items depending on selected City.
      $citySelect.on('change', () => {
        if ($neighborhoodSelect.length) {
          $neighborhoodFormItem.find('.custom-select__options').children('li').removeClass('hidden');
          // Wait until hidden classes applied to select box items.
          setTimeout(() => {
            var neighborhoodHiddenItems = $neighborhoodSelect.children('option.hidden').map(function () {
              return $(this).val();
            }).get();
            $.each(neighborhoodHiddenItems, (i, val) => {
              $neighborhoodFormItem.find('.custom-select__options').children(`li[rel=${val}]`).addClass('hidden');
            });
          }, 50);
        }
      });

      // Toggle Monthly Rent Price fieldset.
      $fieldsetPrice.on('click', function () {
        $(this).toggleClass('active');
      });

      // Stop propagation inside fieldset to avoid parent toggling.
      $('.fieldset-wrapper .fieldset-wrapper', $fieldsetPrice).on('click', (e) => {
        e.stopPropagation();
      });

      // Toggle Min/Max Price wrappers.
      if ($priceMax.length && $priceMin.length) {
        $priceMax.on('click', function () {
          $(this).closest('.form-wrapper').addClass('active');
        });

        $priceMin.on('click', function () {
          $priceMax.closest('.form-wrapper').removeClass('active');
        });
      }

      // Populate Min/Max Price fields with selected values.
      $priceListItems.on('click.price', function () {
        var $this = $(this);
        $this.closest('.form-wrapper').find('.fieldset-legend').text($this.text());
        $this.closest('.form-wrapper').find('input.form-text').val($this.attr('rel'));
      });
    }
  };

  /**
   * Match titles height.
   */
  Drupal.behaviors.rcc_match_height = {
    attach: function (context) {
      var $storyPillars = $('.paragraph--type--story-pillars', context);
      var $spotlightStorypage = $('.spotlight.Storypage', context);

      $(window).on('load resize', () => {
        // Matching height of titles in Story Pillars paragraph.
        if ($storyPillars.length) {
          $storyPillars.each(function () {
            if ($(window).width() > 767) {
              Drupal.behaviors.rcc_match_height.matchHeight($('.story-title', $(this)));
            }
            else {
              $('.story-title', $(this)).height('auto');
            }
          });
        }
        // Matching height of titles in Spotlight Storypage slider.
        if ($spotlightStorypage.length) {
          $spotlightStorypage.each(function () {
            Drupal.behaviors.rcc_match_height.matchHeight($('.eyebrow-light.mobile--only', $(this)));
          });
        }
      });
    },
    matchHeight: function ($title) {
      var maxHeight = 0;

      $title.height('auto');
      $title.each(function () {
        if ($(this).height() > maxHeight) {
          maxHeight = $(this).height();
        }
      });
      $title.height(maxHeight);
    }
  };

  /**
   * Handle Maps component.
   */
  Drupal.behaviors.rcc_maps_component = {
    attach: function (context) {
      var $paragraphMap = $('.paragraph--type--map');
      if (!$paragraphMap.length) {
        return;
      }

      // Move map image below title on mobile
      $(window).on('load resize', function () {
        if (window.innerWidth < 768) {
          $('.map-popup__media').insertBefore('.map-popup__body');
        }
        else {
          $('.map-popup__media').insertAfter('.map-popup__details');
        }
      });

      var $multipleSelect = $('select[multiple]', $paragraphMap);
      if ($multipleSelect.length) {
       $(once('multiple', $multipleSelect)).each(function () {
          var $allOptionItem = $('<option/>', {
            'text': 'All',
            'value': ''
          });
          $(this).prepend($allOptionItem);
        });
      }

      // Mobile map filters display
      $(once('filter', '.mobile-map-filters')).on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('active')) {
          $('.mobile-map-filters').removeClass('active');
          $('.view-filters').removeClass('active');
        } else {
          $('.mobile-map-filters').addClass('active');
          $('.view-filters').addClass('active');
          if ($('.view-display-id-icon_legend_attachment .header-wrapper').hasClass('active')) {
            $('.view-display-id-icon_legend_attachment .header-wrapper').removeClass('active');
            $('.rows-wrapper').removeClass('active');
          }
          e.preventDefault();
        }
        return false;
      });
    }
  };

  /**
   * Handle CTA paragraph.
   */
  Drupal.behaviors.rcc_cta = {
    attach: function (context) {
      $('.cta--paragraph', context).each(function() {  
        var $cta = $(this);
        if (!$cta.length) {
          return;
        }

        var $ctaTitle = $('.cta-para-field-title-element', $cta);
        var $ctaSummary = $('.paragraph--type--cta-paragraphs-content .field--type-text-with-summary', $cta);

        $(window).on('resize', debounce(() => {
          // Make CTA titles height equal.
          if ($(window).width() > 767) {
            Drupal.behaviors.rcc_match_height.matchHeight($ctaTitle);
            Drupal.behaviors.rcc_match_height.matchHeight($ctaSummary);
          }
          if ($(window).width() <= 767) {
            $ctaSummary.height('auto');
            $ctaTitle.height('auto');
          }
        }, 100)).trigger('resize');
      });
    }
  };

  /**
   * Create custom select dropdown.
   *
   * @type {{attach: Drupal.behaviors.rcc_custom_select_dropdown.attach}}
   */
  Drupal.behaviors.rcc_custom_select_dropdown = {
    attach: function (context) {
      var $viewsExposedForm = $('.views-exposed-form, .rcc-rentals-search', context);
      if (!$viewsExposedForm.length) {
        return;
      }

      $(once('bind-select-dropdown', $viewsExposedForm.find('select.form-select'), context)).each(function () {
        var $this = $(this);
        var numberOfOptions = $this.children('option').length;

        $this.addClass('visuallyhidden');
        $this.wrap('<div class="custom-select"></div>');
        $this.after('<div class="custom-select__current-option"></div>');

        var $selectedOption = $this.next('div.custom-select__current-option');
        $selectedOption.text($this.children('option:selected').text());

        var $list = $('<ul />', {
          'class': 'custom-select__options'
        }).insertAfter($selectedOption);

        for (var i = 0; i < numberOfOptions; i++) {
          $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val(),
            'class': $this.children('option').eq(i).is(':selected') ? 'checked' : ''
          }).appendTo($list);
        }

        if ($this.prop('multiple')) {
          var $allListItem = $list.children('li[rel=""]');
          $allListItem.addClass('all');
          var $selectedItems = $this.children(':selected');
          if ($selectedItems.length) {
            var selectedItemsText = $selectedItems.map(function () {
              return $(this).text();
            }).get();
            $selectedOption.text(selectedItemsText.join(', '));
          }
          else {
            $selectedOption.text($allListItem.text());
          }
        }

        var $listItems = $list.children('li');

        $selectedOption.click(function (e) {
          e.stopPropagation();
          $('.custom-select__current-option.active').not(this).each(function () {
            $(this).removeClass('active').next('ul.custom-select__options').hide();
          });
          $(this).toggleClass('active').next('ul.custom-select__options').toggle();
        });

        $listItems.click(function (e) {
          var $currentListItem = $(this);
          e.stopPropagation();
          $selectedOption.removeClass('active');

          if ($this.prop('multiple')) {
            $currentListItem.toggleClass('checked');
            var $itemAll = $list.children('li.all');

            if ($(e.target).hasClass('all')) {
              $itemAll.siblings().removeClass('checked');
            }

            var $selectedItems = $list.children('.checked').not($itemAll);
            if ($selectedItems.length) {
              $itemAll.removeClass('checked');
              var selectedItemsText = $selectedItems.map(function () {
                return $(this).text();
              }).get();
              var selectedItemsValues = $selectedItems.map(function () {
                return $(this).attr('rel');
              }).get();
              $selectedOption.text(selectedItemsText.join(', '));
              $this.val(selectedItemsValues);
            }
            else {
              $itemAll.addClass('checked');
              $selectedOption.text($itemAll.text());
              $this.val(['']);
            }
          }
          else {
            $selectedOption.text($currentListItem.text());
            $currentListItem.siblings().removeClass('checked');
            $currentListItem.addClass('checked');
            $this.val($currentListItem.attr('rel'));
          }

          $this.change();
          $list.hide();
        });

        $(document).click(function () {
          $selectedOption.removeClass('active');
          $list.hide();
        });
      });
    }
  };

  /**
   * Handle Data facts and Stats slick slider.
   */
  Drupal.behaviors.rcc_dfs_slick_slider = {
    attach: function attach(context) {

      if ($(window).width() < 767) {
        $('.slide-data-content.slick').parents('.slide-data-wrapper').css('height', 650 + 'px');
      }

      if ($.fn.slick) {
        var $slickclass = $('.slide-data-wrapper .slick', context);
        var dfsslick =  $slickclass.slick({
          speed: 300,
          slidesPerRow: 1,
          slidesToScroll: 1,
          slidesToShow: 1,
          initialSlide: 0,
          infinite: false,
          dots: true,
          arrows: true,
          draggable: true,
          accessibility: false,
          centerMode: true,
          centerPadding: '0px',
        });
        var dotdfsarrows = $slickclass.find('.slick-dots');
        if(dotdfsarrows.length  > 0){
          if(!dotdfsarrows.find('.slick-prev').length){
            dotdfsarrows.prepend($('<span class="previous dfs-prev slick-prev"></span>'));
          }
          if(!dotdfsarrows.find('.slick-next').length){
            dotdfsarrows.append($('<span class="next dfs-next slick-next"></span>'));
          }

        }
        $(document).on('click','.dfs-prev', function(e){
          e.preventDefault();
	      	$(this).closest('.slick-slider').slick('slickPrev');

        });
        $(document).on('click','.dfs-next', function(e){
          e.preventDefault();
          $(this).closest('.slick-slider').slick('slickNext');

        });
      }
    }
  };

  /**
   * Global Visiblity Function.
   */
  Drupal.behaviors.rcc_visibilityCheck = {
    attach: function (context) {
      $.fn.isElemVisible = function (partial) {
        var $t = $(this);
        var $w = $(window);
        var viewTop = $w.scrollTop();
        var viewBottom = viewTop + $w.height();
        var _top = $t.offset().top;
        var _bottom = _top + $t.height();
        var compareTop = partial === true ? _bottom : _top;
        var compareBottom = partial === true ? _top : _bottom;
        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
      };
    }
  };

  /**
   * Handle anchor link action on load.
   */
  Drupal.behaviors.rcc_anchorlink_section = {
    attach: function attach(context) {
      // Function that performs a scroll animation based on the distance value provided
      function scrollToTopAnimation(distance) {
        $('html, body').animate({ scrollTop: distance }, 800, 'linear')        
      }

      $(document).ready(function () {
        // Check for views reference paragraph
        if ($('a.viewsanchorlink').length > 0) {
          $('a.viewsanchorlink').each(function (i, el) {
            var _viewelem = $(el);
            var _parentPara = _viewelem.closest('.views-reference-para');
            if (_parentPara.length) {
              var _anchorlinkexist = _parentPara.children('.hash-anchorlink:not(.viewsanchorlink)');
              if (_anchorlinkexist.length) {
                _viewelem.removeClass('hash-anchorlink').remove();
              }
            }
          });
        }
      });
      $(window).on('load', function () {
        var _isHashed = false;
        var _hashAnchorLink = $('section.hash-anchorlink');
        if (_hashAnchorLink.length > 0) {
          var offset = $(window).width() <= 1023 ? 50 : 100;

          // On Page Load, scroll to Hash link
          if (window.location.hash != '') {
            var $refId = window.location.hash;
            if ($($refId).length) {
              var _top = $($refId).offset().top - offset;
              setTimeout(function () {
                scrollToTopAnimation(_top);
              }, 300);
            }
          }

          // On Click Event of the Story Pillar link
          $('a.story-link').on('click', function(e) {
            var $refId = $(this).attr('href');
            if($refId.charAt(0) === '#'){
              e.preventDefault();
              if ($($refId).length) {
                var _top = $($refId).offset().top - offset;
                scrollToTopAnimation(_top);
              }
            }
          });
          // On Scroll Check hash link exist and apend to url.
          $(window, context).on('resize scroll', function(e) {
            e.preventDefault();
            var scroll = $(window).scrollTop();
            _hashAnchorLink.each(function (i, el) {
              var $el = $(el);
              var $hashid = ($el.attr('id')?$el.attr('id'):'');
              // check visibility.
              if ($el.isElemVisible(true)) {
                if ($hashid != '') { // check if not exist.
                  var $hash = '#' + $hashid;
                  if (history.pushState) {
                    window.history.pushState(null, null, $hash);
                  } else {
                    window.location.hash = $hash;
                  }
                  _isHashed = true;
                  return false;
                } else { // then remove old hash url.
                  if (history.pushState) {
                    window.history.replaceState(null, null, ' ');
                  } else {
                    window.location.hash = '';
                  }
                  _isHashed = false;
                  return false;
                }
              } else {
                _isHashed = false;
              }
            });

            // On page top Remove Hash.
            if (!_isHashed && scroll < 5) {
              if (history.pushState) {
                window.history.replaceState(null, null, ' ');
              } else {
                window.location.hash = '';
              }
              return false;
            }
          });
        }
      });
    }
  };

  /**
   * Check/Uncheck all checkboxes.
   */
  Drupal.behaviors.newsletter_checkAll = {
    attach: function (context, settings) {
      if ($('.field--name-field-newsletter-signup-form').length > 0){
        var _newsBoxes = $('.field--name-field-newsletter-signup-form').find('.newsletter-topic-selection');
        var _html = '<div class="form-item js-form-type-checkbox form-type-checkbox form-item-newsletter-select-all">';
            _html += '<input type="checkbox" class="form-checkbox newsletter-select-all" id="newsletter-select-all-ref" />';
            _html += '<label for="newsletter-select-all-ref" class="option newsletter-select-all">&nbsp;All</label></div>';
            console.log(_html);
        if (_newsBoxes.length){
          var _formCheckboxes = _newsBoxes.find('.fieldset-wrapper').find('.form-checkboxes');
          _formCheckboxes.once().prepend($(_html));
        }
        // Click Options
        $(".newsletter-select-all").on('click', function () {
          $(this).parent().parent().find('.form-type-checkbox input[type=checkbox]').prop('checked', this.checked);
        });
        // Remove Checked for all options.
        $('.newsletter-topic-selection').find('.form-type-checkbox input[type=checkbox]').on('change click', function() {
          var ischecked= $(this).is(':checked');
          if(!ischecked) {
            $('.form-item-newsletter-select-all input[type=checkbox]').prop('checked', false);
          }
        });
      }
    }
  };

  /**
    *
    * RCC Webform Validations
    *
    */
  Drupal.behaviors.rcc_form_validations = {
    attach: function attach(context, settings) {
      $(document).on('submit','form.webform-submission-form',function(e) {
        var isValid = true;
        var gRecaptcha = $(this).find('.g-recaptcha');
        var errorMsg = '';
        if (gRecaptcha.length) {
          gRecaptcha.removeClass('error-recaptcha').next('span.error-text').remove();
          if(grecaptcha.getResponse() == '') {
              isValid = false;
              errorMsg = 'Please complete the reCAPTCHA challenge!';
              gRecaptcha.addClass('error-recaptcha');
              gRecaptcha.after('<span class="error-text recaptcha">' + errorMsg + '</span>');
          }
        }

        if (isValid) {
          return true;
        }
        else {
          return false;
        }
      });

    }
  };

  /**
    *
    * Select2 WCAG Updates
    *
    */
  Drupal.behaviors.rcc_select2_wcag = {
    attach: function attach(context, settings) {
      $(document).ready(function () {
        var select2_elements = $(this).find('.select2-selection__rendered');
        $(select2_elements).each(function() {
          var select_rendered_label = $(this).parent().find('label');
          // A variable to only store the immediate text of the selection element and disregard any children's text
          var select_rendered_text = $(this).clone() // clone the element
          .children() // select all the children
          .remove() // remove all the children
          .end() // go back to selected element
          .text();

          // If a label already exists for the select2 rendered selection element
          if ($(select_rendered_label).length) {
            $(select_rendered_label).text(select_rendered_text);
          }
          else {
            $('<label for='+ $(this).attr('id') +' class="visually-hidden">'+ select_rendered_text +'</label>').insertBefore($(this));
          }
        });
      });
    }
  };

  /**
   *
   * Handle Related Ross logo
   */
  Drupal.behaviors.rcc_logo_adjust_header = {
    attach: function attach(context, settings) {
      $(document).ready(function () {
        if($('header #related-ross-sitebranding-logo').length) {
          $('#main').addClass('related-ross');
        }
      });
    }
  };
})(jQuery, window.Drupal, Drupal.debounce, once);
